export default __webpack_public_path__ + "static/media/element_56.8334a4c9.avif";